<template>
  <div class="account-container">
    <div class="account-bg" v-on:click="close"></div>

    <div class="account-form-wrapper j-account-form-wrapper">
      <transition name="tipsfade">
        <div class="err-tips" v-show="postError">
          <div class="wrapper">
            <i class="tips-icon"></i>
            <p class="tips-text">{{ postErrorTips }}</p>
          </div>
        </div>
      </transition>
      <button class="closeBtn" v-on:click="close" v-show="isSwitchAccount"></button>
      <transition name="fade">
        <div class="login-container" v-show="showLogin">
          <label class="account-editor-label" for="userName-log">
            <i class="editor-icon editor-user-icon"></i>
            <input
              type="text"
              placeholder="請輸入帳號"
              class="account-editor"
              v-on:change="validataUserNameLog('pt_login')"
              v-model="userNameLog"
              id="userName-log"
              @blur="userActionMark('点击账号输入框')"
            />
          </label>
          <div class="account-editor-label password-editor-label" for="password-log">
            <label class="editor-icon editor-password-icon" for="password-log"></label>
            <i class="forget-icon" v-on:click="showForgetBtn = true"></i>
            <transition name="fade">
              <a
                class="forget-btn"
                target="blank"
                v-show="showForgetBtn"
                v-bind:href="forgetLink"
              >忘記密碼</a>
            </transition>
            <input
              type="password"
              placeholder="請輸入密碼"
              class="account-editor"
              v-on:focus="showForgetBtn = false"
              v-model="passwordLog"
              id="password-log"
              @blur="userActionMark('点击密码输入框')"
            />
          </div>
          <label
            v-show="showVerificationLog"
            class="account-editor-label verfication-label"
            for="verification-Code-log"
          >
            <i class="editor-icon editor-verification-icon"></i>
            <input
              type="text"
              placeholder="請輸入驗證碼"
              class="account-editor"
              v-model="verificationLog"
              id="verification-Code-log"
              @blur="userActionMark('点击验证码输入框')"
            />
            <img
              class="verification-code"
              v-on:click="updateLoginVerificationCode"
              v-bind:src="verificationSrcLog"
            />
          </label>
          <!-- <label class="submitWrapper"> -->
          <button class="submitBtn" v-on:click="login" type="button">登入</button>
          <!-- </label> -->
          <p class="loginTips">
            沒有帳號？馬上
            <a class="switchLoginBtn" v-on:click="switchToRegist">免費註冊</a>
          </p>
          <div class="orLine"></div>
          <a class="fbLoginBtn" @click="doFbLogin" href="javascript:;"></a>
          <button
            class="touristLoginBtn"
            v-on:click="doTouristLogin"
            v-if="pageInfo.tourist"
            type="button"
          ></button>
        </div>
      </transition>
      <transition name="fade">
        <div class="register-container" v-show="!showLogin">
          <form>
            <label class="account-editor-label" for="userName">
              <i class="editor-icon editor-user-icon"></i>
              <input
                type="text"
                placeholder="請輸入帳號"
                v-on:change="validataUserNameReg"
                v-model="userName"
                class="account-editor"
                id="userName"
                @blur="userActionMark('点击注册账号输入框')"
              />
            </label>
            <label class="account-editor-label" for="password">
              <i class="editor-icon editor-password-icon"></i>
              <input
                type="password"
                placeholder="請輸入密碼"
                v-model="password"
                class="account-editor"
                id="password"
                @blur="userActionMark('点击注册密码输入框')"
              />
            </label>
            <label class="account-editor-label" for="confirm-password">
              <i class="editor-icon editor-password-icon"></i>
              <input
                type="password"
                placeholder="再次輸入密碼"
                v-model="confirmPassword"
                class="account-editor"
                id="confirm-password"
                @blur="userActionMark('点击注册密码二次输入框')"
              />
            </label>
            <label
              v-show="showVerificationReg"
              class="account-editor-label"
              for="verification-Code"
            >
              <i class="editor-icon editor-verification-icon"></i>
              <input
                type="text"
                placeholder="請輸入驗證碼"
                v-model="verification"
                class="account-editor"
                id="verification-Code"
                @blur="userActionMark('点击注册验证码输入框')"
              />
              <img
                class="verification-code"
                v-on:click="updateRegistVerificationCode"
                v-bind:src="verificationSrcReg"
              />
            </label>
            <div class="items-contianer">
              <div class="checkbox checked"></div>
              <p>
                我同意
                <a
                  target="_blank"
                  href="https://msupport.gm99.com/About/termsofuse"
                  class="items"
                >G妹遊戲服務條款</a>和
                <a
                  target="_blank"
                  href="https://msupport.gm99.com/About/privacypolicy"
                  class="items"
                >隱私條款</a>
              </p>
            </div>
            <!-- <label class="submitWrapper"> -->
            <button class="submitBtn" type="button" v-on:click="regist">註冊</button>
            <!-- </label> -->
            <p class="loginTips">
              已有帳號？
              <a class="switchLoginBtn" v-on:click="switchToLogin">立即登入</a>
            </p>
          </form>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
import user, {
  LOGIN,
  REGIST,
  GET_USER_INFO,
  VERIFICATION_STATE,
  FB_LOGIN,
} from "../store/user";
import {
  MESSAG_REGIST,
  MESSAG_LOGIN,
  MESSAG_SWITCH,
} from "../utile/constRegist";
import { isPhone } from "../utile/device";
import {
  ACCOUNT_LOGIN,
  ACCOUNT_REGIST,
  // SWITCH_ACCOUNT,
  // LOGIN_ACCOUNT,
  LOGIN_SUCCESS,
  REGIST_SUCCESS,
  MOBILE_GAME_PAGE_URL,
  GAME_ID,
} from "../utile/constRegist";
import {
  validateEmpty,
  loginValidate,
  registValidate,
} from "../store/validator";
import { getHrefParam } from "../store/ultile";
import { fbSdkLogin, fbSdkGetState, getFingerprint } from "../utile/fb";
import { mapActions, mapGetters } from "vuex";

export const ACCOUNT_TYPE = {
  switchAccount: Symbol(),
  loginAccount: Symbol(),
  registerAccount: Symbol(),
};

export default {
  name: "accountView", //登录注册功能
  data() {
    return {
      showLogin: !(getHrefParam("register") === "1"), //控制显示登录还是注册
      userNameLog: "",
      passwordLog: "",
      verificationLog: "",
      userName: "",
      password: "",
      confirmPassword: "",
      verification: "",
      verificationSrcLog: "",
      verificationSrcReg: "",
      postError: false,
      postErrorTips: "",
      isLoginAccount: this.loginType == ACCOUNT_TYPE.loginAccount,
      isSwitchAccount: this.loginType == ACCOUNT_TYPE.switchAccount,
      showForgetBtn: false,
      canClick: true,
      forgetLink: isPhone()
        ? "//service.gm99.com/#/password_reset"
        : "//service.gm99.com/center?type=password",
    };
  },
  props: ["loginType", "show", "accoutOpsType"],
  computed: {
    showVerificationLog() {
      return user.state.loginCkcodeStatus;
    },
    showVerificationReg() {
      return user.state.registCkcodeStatus;
    },
    ...mapGetters(["pageInfo"]),
  },
  created() {
    this.updateLoginVerificationCode();
  },
  watch: {
    show: function (show) {
      if (show) {
        // 当展示的时候，初始化 是登录框还是注册框
        // 判断是否史登录类型，还是注册类型
        if (this.accoutOpsType == ACCOUNT_LOGIN) {
          this.updateLoginVerificationCode();
        } else {
          this.updateRegistVerificationCode();
        }
      }
      if (this.userNameLog) {
        this.validataUserNameLog("pt_login");
      }
    },
    loginType(newV, oldV) {
      this.isSwitchAccount = newV === ACCOUNT_TYPE.switchAccount;
      this.isLoginAccount = newV === ACCOUNT_TYPE.loginAccount;
      this.showLogin = newV !== ACCOUNT_TYPE.registerAccount;
    },
  },
  mounted() {
    if (window.addEventListener) {
      window.addEventListener("message", this.messageHandler.bind(this), false);
    } else {
      window.attachEvent("message", this.messageHandler.bind(this));
    }
  },
  methods: {
    close() {
      this.showLogin = true;
      this.$emit("hideAccountPopup");
    },
    showError(errmsg) {
      this.postErrorTips = errmsg;
    },

    switchToLogin() {
      this.showLogin = true;
      this.updateLoginVerificationCode();
      this.gaStatistics({
        eventName: "page_action",
        data: { action_name: "点击切换至账号登录界面" },
      });
    },
    switchToRegist() {
      this.showLogin = false;
      this.updateRegistVerificationCode();
      this.gaStatistics({
        eventName: "page_action",
        data: {
          action_name: "点击切换至账号注册界面",
        },
      });
    },
    updateLoginVerificationCode() {
      let src = "//passport.gm99.com/verify_image?rnd=" + Math.random();
      this.verificationSrcLog = src;
    },
    updateRegistVerificationCode() {
      let src = "//passport.gm99.com/verify_image?rnd=" + Math.random();
      this.verificationSrcReg = src;
    },
    validataUserNameLog(type) {
      if (/\#/.test(this.userNameLog)) {
        this.loginFail("用戶名6-16位字元，區分大小寫", "pt_login");
        return new Promise((resolve) => {
          resolve();
        });
      } else {
        return this.$store.dispatch(VERIFICATION_STATE, this.userNameLog);
      }
    },
    validataUserNameReg() {
      if (/\#/.test(this.userName)) {
        this.registFail("用戶名6-16位字元，區分大小寫");
        return new Promise((resolve) => {
          resolve();
        });
      } else {
        return this.$store.dispatch(VERIFICATION_STATE, this.userName);
      }
    },
    [MESSAG_REGIST]() {
      this.showLogin = false;
    },
    [MESSAG_LOGIN]() {
      this.showLogin = true;
    },
    [MESSAG_SWITCH]() {
      this.showLogin = true;
    },
    messageHandler(evt) {
      var ev = evt || event;
      let action = ev.data.action;
      if (!!action && !!this[action]) {
        this[action]();
      }
    },
    doTouristLogin() {
      if (!this.canClick) {
        return;
      }
      this.canClick = false;
      this.gaStatistics({
        eventName: "login_type",
        data: { login_type: "mv" },
      });
      getFingerprint()
        .then(
          (res) => {
            return this.touristLogin({
              loginId: res,
            });
          },
          (res) => {
            this.loginFail(res, "mv");
          }
        )
        .then(
          () => {
            this.loginSucc("mv");
          },
          (res) => {
            this.loginFail(res, "mv");
          }
        );
    },
    doFbLogin() {
      if (!this.canClick) {
        return;
      }
      this.canClick = false;

      fbSdkGetState().then((res) => {
        if (res.status === "connected") {
          this.$store
            .dispatch(FB_LOGIN, {
              accessToken: res.authResponse.accessToken,
            })
            .then(() => {
              this.loginSucc("fb");
            }, this.fbLoginFail);
        } else {
          fbSdkLogin().then((response) => {
            if (response.status === "connected") {
              this.canClick = true;
              this.doFbLogin();
            } else {
              this.fbLoginFail();
            }
          });
        }
      });

      this.gaStatistics({
        eventName: "login_type",
        data: { login_type: "fb" },
      });
    },
    fbLoginFail(res) {
      let realmsg = (res && res.errmsg) || "登錄失敗";
      // 登录失败，显示失败信息
      this.loginFail(realmsg, "fb");
      this.canClick = true;
    },

    setAccountErrorState() {
      this.postError = true;
      setTimeout(() => {
        this.postError = false;
      }, 3000);
    },

    loginSucc(type) {
      this.showLogin = true;
      this.close();
      this[GET_USER_INFO]({ isCheck: false, loginType: type });
      this.canClick = true;
      this.gaStatistics({
        eventName: "login_success",
        data: {
          login_type: type,
        },
      });
    },

    loginFail(errmsg, type) {
      this.showLogin = true;
      this.canClick = true;
      this.$emit("loginFail", errmsg);
      this.setAccountErrorState();
      this.showError(errmsg);
      this.gaStatistics({
        eventName: "login_fail",
        data: {
          login_type: type,
          msg: errmsg,
        },
      });
    },
    registFail(errmsg) {
      this.showLogin = false;
      this.$emit("registFail", errmsg);
      this.setAccountErrorState();
      this.showError(errmsg);
      this.gaStatistics({
        eventName: "login_fail",
        data: {
          login_type: "pt_register",
          msg: errmsg,
        },
      });
    },

    doLogin(loginSuccess, errMessage) {
      this.gaStatistics({
        eventName: "login_type",
        data: { login_type: "pt_login" },
      });
      var account = this.getLoginAccount();
      return this.$store.dispatch(LOGIN, account);
    },

    getLoginAccount() {
      return {
        uname: this.userNameLog,
        password: this.passwordLog,
        remember: true,
        forward:
          getHrefParam("forward") ||
          encodeURIComponent(window.location.href.replace(/mlocal./, "m.")),
        ckcode: this.verificationLog,
        is_change: this.isSwitchAccount ? 1 : 0,
      };
    },

    // 登录结束后，如果登录成功，加载用户信息，并且向外触发登录成功的事件
    onLoginFinish({ loginResult, errmsg }) {
      if (loginResult) {
        this.showLogin = true;
        this.close();
        this[GET_USER_INFO]({ isCheck: false, loginType: "pt_login" });
        this.gaStatistics({
          eventName: "login_success",
          data: {
            login_type: "pt_login",
          },
        });
      } else {
        // 登录失败，显示失败信息
        this.loginFail(errmsg, "pt_login");
        if ("密碼錯誤" == errmsg) {
          this.showForgetBtn = true;
        }
      }
      this.verificationLog = "";
      this.updateLoginVerificationCode();
      this.canClick = true;
    },

    login() {
      if (this.postError) {
        return;
      }
      if (this.canClick) {
        var account = this.getLoginAccount();
        var validateRes = loginValidate(account, this.$store.state.user);
        if (validateRes.dirty) {
          this.loginFail(validateRes.msg, "pt_login");
          return;
        }
        this.canClick = false;
        this.validataUserNameLog("pt_login")
          .then(this.doLogin.bind(this))
          .then(this.onLoginFinish.bind(this));
      }
    },
    getRegistAccount() {
      return {
        uname: this.userName,
        password: this.password,
        repassword: this.confirmPassword,
        forward:
          getHrefParam("forward") ||
          encodeURIComponent(window.location.href.replace(/mlocal./, "m.")),
        ckcode: this.verification,
      };
    },
    doRegist() {
      this.gaStatistics({
        eventName: "login_type",
        data: { login_type: "pt_register" },
      });

      var account = this.getRegistAccount();
      return this.$store.dispatch(REGIST, account);
    },
    // 注册后，如果成功，加载用户信息，并且向外触发登录成功的事件
    onRegistFinish({ regestResult, errmsg, forward }) {
      if (regestResult) {
        this.showLogin = true;
        this.close();
        this[GET_USER_INFO]({ isCheck: false, loginType: "pt_register" });
        this.gaStatistics({
          eventName: "login_success",
          data: {
            login_type: "pt_register",
          },
        });
      } else {
        this.registFail(errmsg);
      }
      this.updateRegistVerificationCode();
      this.canClick = true;
    },
    regist() {
      if (this.postError) {
        return;
      }
      if (this.canClick) {
        var account = this.getRegistAccount();
        var validateRes = registValidate(account);
        if (validateRes.dirty) {
          this.registFail(validateRes.msg);
          return;
        }
        this.canClick = false;
        this.validataUserNameReg()
          .then(this.doRegist.bind(this))
          .then(this.onRegistFinish.bind(this));
      }
    },
    userActionMark(actionName) {
      this.gaStatistics({
        eventName: "page_action",
        data: {
          action_name: actionName,
        },
      });
    },
    ...mapActions([GET_USER_INFO, "touristLogin", "gaStatistics"]),
  },
};
</script>

<style lang="scss">
@import "../assets/scss/_dimen";
@import "../assets/scss/_mixins";
$imgURL: "../assets/img/";
$divide: 10 !default;
$pswWidth: 750;
.account-bg {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 1;
  background: black;
  opacity: 0.6;
  cursor: pointer;
}
.account-form-wrapper {
  position: relative;
  z-index: 10;
  width: 727px;
  height: 1057px;
  box-sizing: border-box;
  padding: 330px 64px;
  padding-bottom: 0;
  background: url($imgURL + "accountBg.png");
  background-size: 100% 100%;
}
.login-container,
.register-container {
  position: absolute;
  top: 330px;
  width: (727px - 64px * 2);
  text-align: center;
  left: 50%;
  margin-left: -300px;
  .account-editor-label {
    position: relative;
    height: 48px;
    border-radius: 10px;
    border: 2px solid #f87e19;
    background: white;
    padding-left: (10px * 2 + 48px);
    padding-top: 16px;
    padding-bottom: 16px;
    padding-right: 10px;
    margin-bottom: 34px;
    display: block;
    overflow: hidden;
  }
  .password-editor-label {
    padding-right: (20px + 49px) !important;
  }
  .forget-icon {
    width: 40px;
    height: 40px;
    position: absolute;
    right: 10px;
    top: 20px;
    background-size: 100% 100%;
    background-image: url($imgURL + "icons/forget.png");
    cursor: pointer;
  }
  .forget-btn {
    width: 216px;
    height: 53px;
    text-align: center;
    line-height: 53px;
    font-size: 18px;
    color: #f6880f;
    position: absolute;
    right: 60px;
    top: 16px;
    background-size: 100% 100%;
    background-image: url($imgURL + "icons/tips_bg.png");
  }
  .editor-icon {
    width: 48px;
    height: 48px;
    border-radius: 48px;
    position: absolute;
    left: 10px;
    top: 16px;
    background-size: 100% 100%;
    display: block;
  }
  .account-editor {
    width: 100%;
    height: 100%;
    font-size: 24px;
    line-height: 48px;
    color: #666;
    &::-webkit-input-placeholder {
      color: #aaa;
    }
    &:-webkit-autofill {
      -webkit-box-shadow: 0 0 0 400px white inset;
    }
    &::-internal-input-suggested {
      font-size: 24px !important;
    }
  }
  .editor-user-icon {
    background-image: url($imgURL + "icons/userNameIcon.png");
  }
  .editor-password-icon {
    background-image: url($imgURL + "icons/passwordIcon.png");
  }
  .editor-verification-icon {
    background-image: url($imgURL + "icons/verificationCode.png");
  }
}
.items-contianer {
  height: 35px;
  // padding-left: 5px ;
  line-height: 35px;
  font-size: 22px;
  .checkbox {
    width: 35px;
    height: 35px;
    background-size: 100% 100%;
    background-image: url($imgURL + "icons/checkBox.png");
    float: left;
    margin-right: 16px;
    &.checked {
      background-image: url($imgURL + "icons/checked.png");
    }
  }
  .items {
    color: #1782e6;
    text-decoration: none;
  }
  p {
    text-align: left;
  }
}
input::-internal-input-suggested {
  font-size: 24px !important;
}
.submitWrapper {
  width: 100%;
  text-align: center;
  display: block;
  margin-top: 43px;
  margin-bottom: 30px;
}
.submitBtn {
  width: 344px;
  height: 81px;
  margin: 43px auto 30px;
  background: #f87e19;
  text-align: center;
  line-height: 81px;
  font-size: 28px;
  color: white;
  border-radius: 40px;
  display: block;
  cursor: pointer;
}
.loginTips {
  width: 100%;
  text-align: center;
  font-size: 24px;
  color: #aaa;
}
.switchLoginBtn {
  cursor: pointer;
  color: #f87319;
  text-decoration: none;
}
.orLine {
  height: 28px;
  width: 100%;
  margin-top: 40px;
  margin-bottom: 40px;
  background-image: url($imgURL + "icons/loginLine.png");
  background-size: 100% 100%;
}
.fbLoginBtn {
  display: inline-block;
  margin: 0 20px;
  width: 241px;
  height: 48px;
  background-color: transparent;
  background-image: url($imgURL + "icons/FBLogin.png");
  background-size: 100% 100%;
  cursor: pointer;
}
.touristLoginBtn {
  display: inline-block;
  margin: 0 20px;
  width: 172px;
  height: 48px;
  background-color: transparent;
  background-image: url($imgURL + "icons/touristLogin.png");
  background-size: 100% 100%;
  cursor: pointer;
}
.verfication-label {
  padding-right: 210px;
}
.verification-code {
  position: absolute;
  right: 0;
  top: 0;
  height: 100%;
  width: 200px;
  border-radius: 0 10px 10px 0;
  border: 0;
}
.closeBtn {
  position: absolute;
  width: 22px;
  height: 22px;
  top: 52px;
  right: 33px;
  cursor: pointer;
  background-size: 100% 100%;
  background-color: transparent;
  background-image: url($imgURL + "icons/closeBtn.png");
}
.err-tips {
  position: absolute;
  left: 0;
  padding: 0 80px;
  box-sizing: border-box;
  height: 67px;
  width: 100%;
  top: 50%;
  margin-top: -67px/2;
  z-index: 50;
  overflow: hidden;
  .wrapper {
    position: relative;
    background: rgba(0, 0, 0, 0.6);
    height: 100%;
    width: 100%;
    box-sizing: border-box;
    padding: 20px 24px;
    padding-left: (24px + 29px + 9px);
    overflow: hidden;
  }
  .tips-icon {
    position: absolute;
    height: 29px;
    width: 29px;
    left: 24px;
    top: 20px;
    float: left;
    display: block;
    background-size: 100% 100%;
    background-image: url($imgURL + "icons/account-tip-icon.png");
  }
  .tips-text {
    width: 100%;
    height: 100%;
    line-height: 29px;
    overflow-x: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    color: #ffffff;
    overflow: hidden;
    font-size: 24px;
  }
}

.tipsfade-enter-active,
.tipsfade-leave-active {
  transition: opacity 0.3s;
}

.tipsfade-enter,
    .tipsfade-leave-to
    /* .fade-leave-active in below version 2.1.8 */ {
  opacity: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/Account.vue